import api from './client'

// VENTAS → Sommelier IA: lectura de consultas, carrito y compra; y el
// cuaderno de lecciones (17 sep 2026): el cron propone, acá se aprueba,
// descarta o retira.
export const sommelierApi = {
  consultas: (params) => api.get('/marketing/sommelier-consultas', { params }),
  lecciones: (params) => api.get('/marketing/sommelier-lecciones', { params }),
  aprobarLeccion: (id, motivo) => api.post(`/marketing/sommelier-lecciones/${id}/aprobar`, { motivo }),
  descartarLeccion: (id, motivo) => api.post(`/marketing/sommelier-lecciones/${id}/descartar`, { motivo }),
  retirarLeccion: (id, motivo) => api.post(`/marketing/sommelier-lecciones/${id}/retirar`, { motivo }),
}
